// extracted by mini-css-extract-plugin
export default {"DrawerNav":"style_DrawerNav__jGZEt","DrawerNav__amount":"style_DrawerNav__amount__UJa5M","DrawerNav__btnCon":"style_DrawerNav__btnCon__iMOrX"};